import {
  AuthenticationResult,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useHandleAuthError } from '../lib/useAuthError';

export const useEventHandling = () => {
  const { instance } = useMsal();
  const [authInteractionInProgress, setAuthInteractionInProgress] =
    useState(false);
  const reportAuthError = useHandleAuthError();

  const acquireToken = async (scopes: string[]) => {
    if (!authInteractionInProgress) {
      try {
        setAuthInteractionInProgress(true);
        await instance.acquireTokenRedirect({ scopes });
      } catch (error) {
        if (error instanceof Error) {
          reportAuthError(error, EventType.ACQUIRE_TOKEN_FAILURE, scopes);
        }
      } finally {
        setAuthInteractionInProgress(false);
      }
    }
  };
  const loginRedirect = async (scopes: string[]) => {
    if (!authInteractionInProgress) {
      try {
        setAuthInteractionInProgress(true);
        await instance.loginRedirect({ scopes });
      } catch (error) {
        if (error instanceof Error) {
          reportAuthError(error, EventType.LOGIN_FAILURE, scopes);
        }
      } finally {
        setAuthInteractionInProgress(false);
      }
    }
  };

  useEffect(() => {
    instance.addEventCallback((event: EventMessage) => {
      const handlers: Partial<Record<EventType, () => void>> = {
        [EventType.LOGIN_SUCCESS]: () => {
          const { account } = event.payload as AuthenticationResult;
          instance.setActiveAccount(account);
        },
        [EventType.ACQUIRE_TOKEN_FAILURE]: async () => {
          const payload = event.payload as AuthenticationResult;
          const scopes = payload?.scopes;
          await acquireToken(scopes);
        },
        [EventType.LOGIN_FAILURE]: async () => {
          const payload = event.payload as AuthenticationResult;
          const scopes = payload?.scopes;
          await loginRedirect(scopes);
        },
      };
      handlers[event.eventType]?.();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
